import type { PermissionRuleEntity } from '../../features/user/domain/entities/UserEntity.js';
import type { AclResource, AclAction } from './aclTypes.js';

export class AclService {
  constructor(private readonly rules: PermissionRuleEntity[]) {}

  can(resource: AclResource, action: AclAction): boolean {
    const matches = (r: PermissionRuleEntity) =>
      this.matchResource(r.resource, resource) && this.matchAction(r.action, action);
    if (this.rules.some((r) => r.effect === 'deny' && matches(r))) return false;
    return this.rules.some((r) => r.effect === 'allow' && matches(r));
  }

  private matchResource(rule: string, query: string): boolean {
    if (rule === '*') return true;
    if (rule === query) return true;
    if (rule.endsWith(':*')) return rule.slice(0, -2) === query;
    return false;
  }

  private matchAction(rule: string, query: string): boolean {
    if (rule === '*' || rule === 'manage') return true;
    if (rule === query) return true;
    // edit / delete (full) satisfies edit.me / delete.me requests
    if (query.endsWith('.me') && rule === query.slice(0, -3)) return true;
    return false;
  }
}
